// FieldIQ — Auth endpoints, token storage, authFetch with re-auth queue

export const AUTH_URL =
  process.env.REACT_APP_AUTH_URL ||
  "https://app.hyveappliedintelligence.com/auth";

export const FIELDIQ_API_URL =
  process.env.REACT_APP_FIELDIQ_API_URL ||
  "https://fieldiq-api.hyveappliedintelligence.com";

// ═══════════════════════════════════════════════════════════════════
// PUSH NOTIFICATION HELPERS
// ═══════════════════════════════════════════════════════════════════

export const getToken = () => localStorage.getItem("fieldiq_token");
export const setToken = (t) =>
  t
    ? localStorage.setItem("fieldiq_token", t)
    : localStorage.removeItem("fieldiq_token");

// ── Session expiry gate ──────────────────────────────────────────────
// On 401 we do NOT reload (that would destroy in-progress form state).
// Instead the request pauses, a re-login modal is shown, and the request
// retries once after a successful re-auth. All concurrent 401s share the
// same gate, so the modal only appears once.
let _reauthPromise = null;
let _reauthResolve = null;

const requestReauth = () => {
  if (!_reauthPromise) {
    _reauthPromise = new Promise((resolve) => {
      _reauthResolve = resolve;
    });
    window.dispatchEvent(new Event("fieldiq:session-expired"));
  }
  return _reauthPromise;
};

// success=true → token refreshed, paused requests retry.
// success=false → user logged out / gave up, paused requests fail.
export const settleReauth = (success) => {
  const resolve = _reauthResolve;
  _reauthPromise = null;
  _reauthResolve = null;
  if (resolve) resolve(success);
};

export const authFetch = async (path, opts = {}, _retried = false) => {
  const method = opts.method || "GET";
  const headers = {};
  if (method !== "GET") headers["Content-Type"] = "application/json";
  const token = getToken();
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${AUTH_URL}${path}`, {
    ...opts,
    headers: { ...headers, ...opts.headers },
  });
  if (res.status === 401) {
    if (_retried) return { error: "Session expired" };
    const ok = await requestReauth();
    if (!ok) return { error: "Session expired" };
    return authFetch(path, opts, true);
  }
  if (!res.ok) {
    const t = await res.text();
    return { error: t };
  }
  try {
    return await res.json();
  } catch {
    return {};
  }
};
